export const iconFontAwesomeHandsHandDots = (
	<i className="fa-solid fa-hand-dots"></i>
);
